import { render, staticRenderFns } from "./AlertaCamaraForm.vue?vue&type=template&id=58ba5818&scoped=true&"
import script from "./AlertaCamaraForm.vue?vue&type=script&lang=ts&"
export * from "./AlertaCamaraForm.vue?vue&type=script&lang=ts&"
import style0 from "./AlertaCamaraForm.vue?vue&type=style&index=0&id=58ba5818&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ba5818",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('58ba5818', component.options)
    } else {
      api.reload('58ba5818', component.options)
    }
    module.hot.accept("./AlertaCamaraForm.vue?vue&type=template&id=58ba5818&scoped=true&", function () {
      api.rerender('58ba5818', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/Alertas/AlertaCamaraForm.vue"
export default component.exports